import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../components/table/TableOps'
import { Dialog, Button, Slide } from '@material-ui/core';
import Http from '../../../Http';
import Confirmacion from './Confirmacion';
import ACCESS from '../../../ACCESS';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Confirmaciones extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'preguia/asignadas', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Preguías asignadas', [
        { label: 'Preguía', id: 'id' },
        { label: 'Fecha de recolección', id: 'pg_pro_fecha' },
        { label: 'Fecha de preguía', id: 'pg_fecha_reporte' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Nombre', id: 'cliente_rsocial' },
        { label: 'Transportista', id: 'transportista_nombre' },
      ], [
        { id: 'confirmar', icon: 'check', access: [ACCESS.PREGUIA.CONFIRMAR_RECOLECCION] },
      ]))
    this.table();
    this.loadTransportistas();
  }

  loadTransportistas = async () => {
    let TRes = await Http.get('transportista/all');
    if (!TRes.error) {
      this.setState({ transportistas: TRes.data })
    }
  }

  action = (id, row) => {
    if (id === 'confirmar') {
      this.setState({ tdOpen: true, tdRow: row })
    }
  }

  detallesClose = () => {
    this.setState({ tdOpen: false })

  }

  submitDetalles = async (detalles) => {
    // console.log(this.preguiaVals)
    var { tdRow } = this.state;
    var Res = await Http.post(`preguia/save-preguia`, { preguia: {...detalles, ...detalles.cliente, id_cliente_main: detalles.cliente.id, id: tdRow.id, pg_estado: 5, recolectada: true}, detalles });
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, tdOpen: false });
      this.table();
    }
    else
      this.setState({ loading: false, sbMsg: 'Error al guardar', sbOpen: true });
  }

  render() {
    var { tdOpen, tdRow } = this.state;
    return (
      <div>
        <div>
          <this.TableRender />
        </div>

        <div>
          <Dialog fullScreen open={tdOpen ? tdOpen : false} onClose={this.detallesClose} TransitionComponent={Transition}>
            <div style={{ textAlign: 'right' }}>
              <Button onClick={this.detallesClose}>REGRESAR</Button>
            </div>
            <div>
              <Confirmacion onSave={this.submitDetalles} preguia={tdRow ? tdRow.id : null} />
            </div>
          </Dialog>
        </div>
      </div>
    )
  }
}

export default withRouter(Confirmaciones)
